import React, { memo, SVGProps } from 'react'

export const Rss = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M6.65569 14.9885C5.35585 14.9885 4.29889 16.0454 4.29889 17.3443C4.29889 18.6432 5.35681 19.7011 6.65569 19.7011C7.95457 19.7011 9.01153 18.6432 9.01153 17.3443C9.01153 16.0454 7.95457 14.9885 6.65569 14.9885ZM6.65569 18.2611C6.15073 18.2611 5.73889 17.8493 5.73889 17.3443C5.73889 16.8394 6.15073 16.4285 6.65569 16.4285C7.16065 16.4285 7.57153 16.8394 7.57153 17.3443C7.57153 17.8493 7.16065 18.2611 6.65569 18.2611Z"
      fill="currentColor"
    />
    <path
      d="M6.43681 4.29887C6.03937 4.29887 5.71681 4.62143 5.71681 5.01887C5.71681 5.41631 6.03937 5.73887 6.43681 5.73887C12.9571 5.73887 18.2611 11.0429 18.2611 17.5632C18.2611 17.9606 18.5837 18.2832 18.9811 18.2832C19.3786 18.2832 19.7011 17.9606 19.7011 17.5632C19.7011 10.249 13.751 4.29887 6.43681 4.29887Z"
      fill="currentColor"
    />
    <path
      d="M6.43681 9.58079C6.03937 9.58079 5.71681 9.90335 5.71681 10.3008C5.71681 10.6982 6.03937 11.0208 6.43681 11.0208C10.0445 11.0208 12.9782 13.9555 12.9782 17.5622C12.9782 17.9597 13.3008 18.2822 13.6982 18.2822C14.0957 18.2822 14.4182 17.9597 14.4182 17.5622C14.4182 13.1606 10.8384 9.58079 6.43681 9.58079Z"
      fill="currentColor"
    />
  </svg>
))
